import { Button } from '@medely/ui-kit';
import useDialog from '@mp/hooks/useDialog';
import moment from 'moment';
import React from 'react';
import { useCurrentUser } from '@mp/hooks';
import { calculateLateCancellation } from './cancelationUtils';
import { UtmParamsType } from './interface';
import { CancelShiftDialog } from './cancellationDialog/CancelShiftDialog';
import { JobDetailsFragment } from '../graphql';
import { FragmentType, parseFragmentData } from '@mp/graphql/generated';

type CancelShiftButtonProps = {
  job?: FragmentType<typeof JobDetailsFragment> | null;
  utmParams?: UtmParamsType;
  onCancelSuccess?: () => void;
};

export const CancelShiftButton = ({
  job: inputJob,
  utmParams,
  onCancelSuccess,
}: CancelShiftButtonProps) => {
  const job = parseFragmentData(JobDetailsFragment, inputJob);

  const { isSaas } = useCurrentUser();
  const { open, openDialog, closeDialog } = useDialog();
  const { showLateCancellationWarning } = calculateLateCancellation({
    bookedAt: job?.booked_at,
    currentStartsTime: job?.current_starts_time,
    hasJobAssignment: Boolean(job?.assignment),
    updatedInCancellationWindow: job?.updated_in_cancellation_window,
  });
  const showButton = !(
    job?.status === 'clocked_in' || moment(job?.current_starts_time).isBefore(moment())
  );
  const dialogTitle =
    showLateCancellationWarning && !isSaas ? 'Confirm Late Cancellation' : 'Confirm Cancellation';

  return (
    <>
      {showButton && (
        <Button
          variant="outlined"
          onClick={() => openDialog()}
          testId="cancel-shift-button"
          fullWidth
        >
          Cancel shift
        </Button>
      )}
      <CancelShiftDialog
        open={open}
        onClose={closeDialog}
        title={dialogTitle}
        job={inputJob}
        utmParams={utmParams}
        onCancelSuccess={onCancelSuccess}
      />
    </>
  );
};
